import { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import { Form } from "antd";
import { createEntity, getEntity, reset, updateEntity } from "./spec.reducer";
import EditPage, { EditStateAndDispatchProps } from "layouts/page-wraper/edit-page-modal";
import { Spec } from "model/product/spec.model";
export interface SpecEditProps extends EditStateAndDispatchProps<Spec>, StateProps, DispatchProps, RouteComponentProps {
}

const SpecEdit: FC<SpecEditProps> = props => {
  const [form] = Form.useForm();
  return (
    <EditPage<Spec>
      title="编辑"
      form={form}
      {...props}
    >
    </EditPage>);
};

const mapStateToProps = ({ spec }: RootState) => ({
  entity: spec.entity,
  updateSuccess: spec.updateSuccess,
  updating: spec.updating,
  createSuccess: spec.createSuccess
});

const mapDispatchToProps = {
  getEntity,
  createEntity,
  updateEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SpecEdit);
